import React, { useEffect, useRef } from "react"
import * as styles from "./slider.module.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import { useLocale } from "../../../hooks"

import { Keyboard, Navigation, Pagination } from "swiper"

import { Link } from "gatsby"
import Img from "gatsby-image"
import { useLocalPath, useUrl } from "../../../hooks"

import ReccomendedProduct from "../ReccomendedProduct/ReccomendedProduct"
import ProductsGrid from "../ReccomendedProduct/ProductsGrid"

import { useWindowSize } from "react-use"

export const Slider = ({ data }) => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-navigation-color",
      "#000"
    )
    document.documentElement.style.setProperty(
      "--swiper-pagination-color",
      "#000"
    )
  }, [])

  switch (data.type) {
    case "Products":
      return <ProductSlider data={data} />
    case "Articles":
      return <ArticleSlider data={data} />
    case "Recipes":
      return <RecipeSlider data={data} />
    case "FeaturedProducts":
      return <FeaturedProducts data={data} />
    case "Premiumproduct":
      return <PremiumProducts data={data} />
    case "Featuredrecipes":
      return <Featuredrecipes data={data} />
    case "CommonCarousel":
      return <CommonSlider data={data} />
  }
  return <div></div>
}

export const ArticleSlider = ({ data }) => {
  const locale = useLocale()
  const { width: windowWidth } = useWindowSize()
  const {
    centeredAlign,
    title: sliderTitle,
    articles,
    dynamicBullets,
    articleTriangleAlign,
    navigation,
  } = data

  if (!articles || articles.length === 0) {
    return null; // If there are no articles, return null to render nothing
  }

  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-navigation-size-scientist",
      "2rem"
    )
  }, [])
  const swiperRef = useRef(null)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update()
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev()
    }
  }

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext()
    }
  }

  const option = {
    spaceBetween: 20,
    loop: articles && articles.length > 2 ? true : false,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: false,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: false,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    modules: [Pagination, Navigation],
    slidesPerView: 3,
  }
  return (
    <div>
      <div className={styles.articles}>
        {sliderTitle && (
          <>
            <h2
              className={`yellow_border ${styles.featuredArticleTitle} spacer__01`}
            >
              {sliderTitle}
            </h2>
          </>
        )}
        <div className={`spacer__01 triangle_02 ${articleTriangleAlign}`}>
          <div className={`${styles.swiperContainer}`}>
            {/* <div
              className={`${styles.arrowContainer} ${
                navigation && articles.length <= 3 && styles.displayNavigation
              }`}
            >
              <div
                className={`${styles.prevButton}`}
                id="prev-button"
                onClick={() => {
                  goPrev()
                }}
              ></div>
            </div> */}
            {windowWidth < 1024 ?

              <div className={`${styles.arrowContainer}`}>
                <div
                  className={`${styles.prevButton}`}
                  id="prev-button"
                  onClick={() => {
                    goPrev()
                  }}
                ></div>
              </div>
              : windowWidth > 1023 && articles?.length > 3 ?
                <div className={`${styles.arrowContainer}`}>
                  <div
                    className={`${styles.prevButton}`}
                    id="prev-button"
                    onClick={() => {
                      goPrev()
                    }}
                  ></div>
                </div>
                : null
            }
            <Swiper {...option} ref={swiperRef}>
              {articles && articles.map((article, index) => {
                const {
                  title,
                  slug,
                  thumbnailImage,
                  thumbnailTitle,
                  thumbnailCategoryTitle,
                  articlePageIcon,
                } = article
                return (
                  <SwiperSlide key={index}>
                    <Link to={useLocalPath(`/${slug}`)}>
                      <div className={`${styles.img_wrapper}`}>
                        {articlePageIcon && (
                          <Img
                            fluid={articlePageIcon.fluid}
                            alt={articlePageIcon.title}
                            className={styles.icon}
                          ></Img>
                        )}

                        <p className={styles.titleShadow}>
                          {thumbnailCategoryTitle}
                        </p>
                        {thumbnailTitle ? (
                          <h3 className={styles.titleShadow}>
                            {thumbnailTitle}
                          </h3>
                        ) : (
                          <h3 className={styles.titleShadow}>{title}</h3>
                        )}

                        {locale==="en-US" ? 
                        <Img
                          fluid={thumbnailImage[0].fluid}
                          alt={`Image of ${title}`}
                          className={styles.mainImg}
                        ></Img> : 
                        <Img
                          fluid={thumbnailImage[0].fluid}
                          alt={title}
                          className={styles.mainImg}
                        ></Img>
                        }
                        <div className={styles.triangle_wrapper}>
                          <div className="triangle"></div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                )
              })}
            </Swiper>
            {/* <div
              className={`${styles.arrowContainer} ${
                styles.arrowContainerRight
              } ${
                navigation && articles.length <= 3 && styles.displayNavigation
              } `}
            >
              <div className={`${styles.nextButton}`} onClick={goNext}></div>
            </div> */}

            {windowWidth < 1024 ?
              <div className={`${styles.arrowContainer} ${styles.arrowContainerRight} `}>
                <div
                  className={`${styles.nextButton}`}
                  onClick={goNext}
                ></div>
              </div>
              : windowWidth > 1023 && articles?.length > 4 ?
                <div className={`${styles.arrowContainer} ${styles.arrowContainerRight} `}>
                  <div
                    className={`${styles.nextButton}`}
                    onClick={goNext}
                  ></div>
                </div>
                : null
            }
          </div>
        </div>
      </div>
    </div>
  )
}



export const ProductSlider = ({ data }) => {
  const {
    centeredAlign,
    title,
    products,
    dynamicBullets,
    navigation,
    titleBarColor,
  } = data
  const option = {
    spaceBetween: 20,
    loop: true,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2.5,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 70,
      },
    },
    navigation: navigation,
    modules: [Pagination, Navigation],
    // modules: [Pagination],
    slidesPerView: 3,
  }
  return (
    <div>
      <div className={styles.product}>
        <div className={styles.reccomendedProducts}>
          {/* {title && (
                        <h2 className={`yellow_border spacer__01 ${styles.productSliderTitle}`}>{title}</h2>
                    )} */}

          {title && titleBarColor !== "Green" ? (
            <h2
              className={`yellow_border spacer__01 ${styles.productSliderTitle}`}
            >
              {title}
            </h2>
          ) : title && titleBarColor === "Green" ? (
            <h2
              className={`yellow_border_green spacer__01 ${styles.productSliderTitle}`}
            >
              {title}
            </h2>
          ) : null}

          <Swiper {...option}>
            {products.map((product, index) => {
              if (product?.thumbnailImage && product?.title && product.slug) {
                return (
                  <SwiperSlide key={index}>
                    <div className={`styles.productCard`}>
                      <ReccomendedProduct
                        fluid={product?.thumbnailImage?.fluid}
                        text={product?.title}
                        showButton={true}
                        to={product.slug}
                      />
                    </div>
                  </SwiperSlide>
                )
              }
            })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export const FeaturedProducts = ({ data }) => {
  const { centeredAlign, title, products, dynamicBullets, navigation } = data
  const option = {
    spaceBetween: 20,
    loop: true,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
    },
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
    },
    navigation: navigation,
    modules: [Pagination, Navigation],
    // modules: [Pagination],
    slidesPerView: 3,
  }
  return (
    <div className={styles.reccomendedProducts}>
      {title && (
        <h2 className={`yellow_border spacer__01 ${styles.productHeading}`}>
          {title}
        </h2>
      )}
      <div className={styles.productsGrid}>
        {products.map((product, index) => {
          if (product?.thumbnailImage && product?.title && product.slug) {
            return (
              <SwiperSlide key={index}>
                <div className={`styles.productCard`}>
                  <ReccomendedProduct
                    fluid={product?.thumbnailImage?.fluid}
                    text={product?.title}
                    showButton={true}
                    to={product.slug}
                  />
                </div>
              </SwiperSlide>
            )
          }
        })}
      </div>
    </div>
  )
}


export const PremiumProducts = ({ data }) => {
  const { centeredAlign, title, products, dynamicBullets, navigation } = data

  return (
    <div className={styles.sectionProducts}>
      <div className="container_lg">
      {title && (
        <h2 className={`${styles.underline} ${styles.Heading_label}`}>
          {title}
        </h2>
      )}
      <div className={styles.grid_section}>
        {products.map((product, index) => {
          if (product?.thumbnailImage && product?.title && product.slug) {
            return (
                <div className={styles.productCardSection}>
                  <ProductsGrid
                    fluid={product?.thumbnailImage?.fluid}
                    text={product?.title}
                    showButton={true}
                    to={product.slug}
                    />
                </div>
            )
          }
        })}
      </div>
    </div>
</div>
  )
}


export const RecipeSlider = ({ data }) => {
  const baseUrl = useUrl()
  const {
    centeredAlign,
    title: sliderTitle,
    heading,
    smalltitle,
    recipes,
    dynamicBullets,
    articleTriangleAlign,
    navigation,
  } = data
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-navigation-size-scientist",
      "2rem"
    )
  }, [])
  const swiperRef = useRef(null)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update()
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev()
    }
  }

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext()
    }
  }

  const option = {
    spaceBetween: 20,
    loop: recipes.length > 3 ? true : false,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
      navigation: navigation,
    },
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: false,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: false,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    modules: [Pagination, Navigation, Keyboard],
    slidesPerView: 3,
  }

  if (recipes.length === 0) {
    return null; // Don't render anything if there are no recipes
  }

  return (
    <div>
      <div className={styles.articles}>
        {sliderTitle && (
          <>
            <h2
              className={`yellow_border ${styles.featuredArticleTitle} spacer__01`}
            >
              {sliderTitle}
            </h2>
          </>
        )}
        {heading && (
          <>
            <h2
              className={`yellow_border ${styles.featuredHeading} spacer__01`}
            >
              {heading}
            </h2>
          </>
        )}
        {smalltitle && (
          <>
            <p className={styles.featureSubtitle}>
              {smalltitle}
            </p>
          </>
        )

        }
        <div className={`spacer__01 triangle_02 ${articleTriangleAlign}`}>
          <div className={`${styles.swiperContainer}`}>
            <div
              className={`${styles.arrowContainer} ${navigation && recipes.length <= 3 && styles.displayNavigation
                }`}
            >
              <div
                className={`${styles.prevButton}`}
                id="prev-button"
                onClick={() => {
                  goPrev()
                }}
              ></div>
            </div>
            <Swiper {...option} ref={swiperRef}>
              {recipes.map((recipe, index) => {
                const { title, slug, heroImage, subTitle, recipeIcon } = recipe
                return (
                  <SwiperSlide key={index}>
                    <Link to={useLocalPath(`/${slug}`)}>
                      <div className={`${styles.img_wrapper}`}>
                        {recipeIcon && (
                          <Img
                            fluid={recipeIcon.fluid}
                            alt={recipeIcon.title}
                            className={styles.icon}
                          ></Img>
                        )}
                        <p className={styles.titleShadow}>{subTitle}</p>
                        <h3 className={styles.titleShadow}>{title}</h3>
                        <Img
                          fluid={heroImage.fluid}
                          alt={heroImage.title}
                          className={styles.mainImg}
                        ></Img>
                        <div className={styles.triangle_wrapper}>
                          <div className="triangle"></div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                )
              })}
            </Swiper>
            <div
              className={`${styles.arrowContainer} ${styles.arrowContainerRight
                } ${navigation && recipes.length <= 3 && styles.displayNavigation
                } `}
            >
              <div className={`${styles.nextButton}`} onClick={goNext}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export const Featuredrecipes = ({ data }) => {
  const baseUrl = useUrl()
  const {
    centeredAlign,
    title: sliderTitle,
    heading,
    smalltitle,
    recipes,
    dynamicBullets,
    articleTriangleAlign,
    navigation,
  } = data
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-navigation-size-scientist",
      "2rem"
    )
  }, [])
  const swiperRef = useRef(null)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update()
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev()
    }
  }

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext()
    }
  }

  const option = {
    spaceBetween: 20,
    loop: recipes.length > 0,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
      navigation: navigation,
    },
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: false,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: false,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    modules: [Pagination, Navigation, Keyboard],
    slidesPerView: 3,
  }
  return (
    <div>
      <div className={styles.articles}>
        {sliderTitle && (
          <>
            <h2
              className={`yellow_border ${styles.featuredArticleTitle} spacer__01`}
            >
              {sliderTitle}
            </h2>
          </>
        )}
        {heading && (
          <>
            <h2
              className={`yellow_border ${styles.featuredHeading} spacer__01`}
            >
              {heading}
            </h2>
          </>
        )}
        {smalltitle && (
          <>
            <p className={styles.featureSubtitle}>
              {smalltitle}
            </p>
          </>
        )

        }
        <div className={`spacer__01 triangle_02 ${articleTriangleAlign}`}>
          <div className={`${styles.swiperContainer}`}>
            <div
              className={`${styles.arrowContainer} ${navigation && recipes.length <= 3 && styles.displayNavigation
                }`}
            >
              <div
                className={`${styles.prevButton}`}
                id="prev-button"
                onClick={() => {
                  goPrev()
                }}
              ></div>
            </div>
            <Swiper {...option} ref={swiperRef}>
              {recipes.map((recipe, index) => {
                const { title, slug, heroImage, subTitle, recipeIcon } = recipe
                return (
                  <SwiperSlide key={index}>
                    <a target="_blank" href={useLocalPath(`/${slug}`)}>
                      <div className={`${styles.img_wrapper}`}>
                        {recipeIcon && (
                          <Img
                            fluid={recipeIcon.fluid}
                            alt={recipeIcon.title}
                            className={styles.icon}
                          ></Img>
                        )}
                        <p className={styles.titleShadow}>{subTitle}</p>
                        <h3 className={styles.titleShadow}>{title}</h3>
                        <Img
                          fluid={heroImage.fluid}
                          alt={heroImage.title}
                          className={styles.mainImg}
                        ></Img>
                        <div className={styles.triangle_wrapper}>
                          <div className="triangle"></div>
                        </div>
                      </div>
                    </a>
                  </SwiperSlide>
                )
              })}
            </Swiper>
            <div
              className={`${styles.arrowContainer} ${styles.arrowContainerRight
                } ${navigation && recipes.length <= 3 && styles.displayNavigation
                } `}
            >
              <div className={`${styles.nextButton}`} onClick={goNext}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const CommonSlider = ({ data }) => {
  const baseUrl = useUrl()
  const {
    centeredAlign,
    title,
    carouselItems,
    dynamicBullets,
    articleTriangleAlign,
    navigation,
  } = data
  useEffect(() => {
    document.documentElement.style.setProperty(
      "--swiper-navigation-size-scientist",
      "2rem"
    )
  }, [])
  const swiperRef = useRef(null)
  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current && swiperRef.current.swiper) {
        swiperRef.current.swiper.update()
      }
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  const goPrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev()
    }
  }

  const goNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext()
    }
  }

  const option = {
    spaceBetween: 20,
    loop: carouselItems.length > 2 ? true : false,
    centeredSlides: centeredAlign,
    slidesPerGroupSkip: 1,
    grabCursor: true,
    keyboard: {
      enabled: true,
      navigation: navigation,
    },
    pagination: {
      clickable: true,
      dynamicBullets: dynamicBullets,
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        navigation: false,
      },
      // when window width is >= 480px
      480: {
        slidesPerView: 1.5,
        spaceBetween: 10,
        navigation: false,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
    modules: [Pagination, Navigation, Keyboard],
    slidesPerView: 3,
  }
  return (
    <div>
      <div className={styles.articles}>
        {title && (
          <>
            <h2
              className={`yellow_border ${styles.featuredArticleTitle} spacer__01`}
            >
              {title}
            </h2>
          </>
        )}


        <div className={`spacer__01 triangle_02 ${articleTriangleAlign}`}>
          <div className={`${styles.swiperContainer}`}>
            <div
              className={`${styles.arrowContainer} ${navigation && carouselItems.length <= 3 && styles.displayNavigation
                }`}
            >
              <div
                className={`${styles.prevButton}`}
                id="prev-button"
                onClick={() => {
                  goPrev()
                }}
              ></div>
            </div>
            <Swiper {...option} ref={swiperRef}>
              {carouselItems.map((carouselItem, index) => {
                const { thumbnailTitle, slug, thumbnailImage, categoryThumbnailTitle, thumbnailIcon } = carouselItem
                return (
                  <SwiperSlide key={index}>
                    <Link to={useLocalPath(`/${slug}`)}>
                      <div className={`${styles.img_wrapper}`}>
                        {thumbnailIcon && (
                          <Img
                            fluid={thumbnailIcon.fluid}
                            alt={thumbnailIcon.title}
                            className={styles.icon}
                          ></Img>
                        )}
                        <p className={styles.titleShadow}>{categoryThumbnailTitle}</p>
                        <h3 className={styles.titleShadow}>{thumbnailTitle}</h3>
                        <Img
                          fluid={thumbnailImage.fluid}
                          alt={thumbnailImage.title}
                          className={styles.mainImg}
                        ></Img>
                        <div className={styles.triangle_wrapper}>
                          <div className="triangle"></div>
                        </div>
                      </div>
                    </Link>
                  </SwiperSlide>
                )
              })}
            </Swiper>
            <div
              className={`${styles.arrowContainer} ${styles.arrowContainerRight
                } ${navigation && carouselItems.length <= 3 && styles.displayNavigation
                } `}
            >
              <div className={`${styles.nextButton}`} onClick={goNext}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}